import { SET_RESUME_DEPOSIT } from './resume-deposit.constants.js';

const getters = {
  resumeDepositParams(state) {
    return state.resumeDeposit;
  }
};
const actions = {
  setResumeDeposit({ commit }, payload) {
    commit(SET_RESUME_DEPOSIT, payload);
  }
};
const resumeDeposit = {
  namespaced: true,
  state: {
    resumeDeposit: null
  },
  getters,
  actions,
  mutations: {
    [SET_RESUME_DEPOSIT](state, payload) {
      state.resumeDeposit = payload;
    }
  }
};

export { actions, getters, resumeDeposit };
